import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

type Props = {
  otpauthUrl: string;
  size?: number;
};

/** Renders a standard otpauth:// TOTP enrollment QR for authenticator apps. */
export function MfaEnrollQr({ otpauthUrl, size = 192 }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !otpauthUrl.startsWith('otpauth://')) return;
    void QRCode.toCanvas(canvas, otpauthUrl, {
      width: size,
      margin: 2,
      errorCorrectionLevel: 'M',
      color: { dark: '#0a0a0a', light: '#ffffff' },
    });
  }, [otpauthUrl, size]);

  return (
    <canvas
      ref={canvasRef}
      className="mfa-qr"
      role="img"
      aria-label="Authenticator enrollment QR code"
      width={size}
      height={size}
    />
  );
}
